/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы пользовательских данных в кабинете
   */
  app.UserDataFormView = app.View.extend({
    el: '#user-data-form',
    successPhoneList: false,
    successUserData: false,

    events: {
      'click .update-user-data-button': 'save',
      'click #cancel': 'cancel',
      'click #append-phone': 'appendPhone',
    },

    run: function (options) {
      if (options && options.user) {
        this.user = options.user;
      }

      this.masks = [];
      this.$fields = this.$el.find('.field');
      this.initPhoneMasks();

      this.userPhoneListView = new app.UserDataPhoneListView({
        collection: this.collection,
        el: this.$el.find('.additional-phones'),
      });

      this.userPhoneListView.on(
        'success-user-data-phone-list-view',
        this.toggleOnSuccessPhoneList,
        this
      );

      this.userPhoneListView.on(
        'error-user-data-phone-list-view',
        this.negateSuccessPhoneList,
        this
      );
      this.fillFields();
      this.checkForMobile();
      
    },

    /**
     * Инициализирует маски телефонов
     */
    initPhoneMasks: function () {
      var that = this;

      // проходим по всем кнопкам открытия попапов с выбором страны
      // их может быть несколько, так как можно добавить несколько телефонов
      _.each(this.$('.choice-country'), function (el, index) {
        var input = $(el).prev('.input_phone'),
          model = app.countryFlag,
          number ='';
        // На первом месте - основной телефон.
        if (index > 0) {
          number = that.collection
            .at(index - 1)
            .get('value');
          model = app.countryFlag
            .clone()
            .unset('id')
            .set(app.helpers.PhoneHelper.getCountryCodeFromNumber(number));
        }
        if (input.length) {
          new app.ChoiceCountryView({el: $(el), model: model});
          var value = input.val(),
            code = model.get('code') || '+7',
            phoneInputmask = new app.PhoneInputmaskView({el: input, model: model});
          phoneInputmask.render();
          if (value && value.indexOf(code.replace('+', '')) === 0) {
            input.val(value);
          }
          that.masks.push(phoneInputmask);
        }
      });
    },

    toggleOnSuccessPhoneList: function () {
      this.successPhoneList = true;
      this.toggleOnSuccess();
    },

    negateSuccessPhoneList: function () {
      this.successPhoneList = false;
      this.$('.update-user-data-button').prop('disabled', false);
    },

    /**
     * Мигание только если произошло два события:
     * - Успешно обновлены телефоны
     * - Успешно сохранены данные пользователя
     */
    toggleOnSuccess: function () {
      if (this.successUserData && this.successPhoneList) {
        this.successUserData = false;
        this.successPhoneList = false;
        this.toggle();
        this.trigger('success-user-data-form');
      }
      this.$('.update-user-data-button').prop('disabled', false);
    },

    /**
     * Добавляет поле для ввода телефона
     */
    appendPhone: function () {
      this.userPhoneListView.render();
    },
    
    /**
     * Сохраняет данные в модель this.user
     *
     * @param e Объект события
     */
    save: function (e) {
      var attributes = {};

      // делаем кнопку отключенной
      $(e.currentTarget).prop('disabled', true);

      // сохраняем все данные из полей
      this.$fields.each(function () {
        var type = $(this).attr('type');

        // если тип поля text или tel
        if (_.includes(['text', 'tel'], type)) {
          attributes[this.name] = $(this).val();
        } else if (type === 'checkbox') {
          attributes[this.name] = $(this).prop('checked');
        }
      });
      // attributes.birth_date = $('#birth_year').val() + '-' + $('.birth_month:checked').val() + '-' + $('#birth_day').val();

      // сохраняем текущий список параметров запроса
      var oldExpand = this.user.expand;

      // определяем параметр запроса для проверки согласия на обработку данных
      this.user.expand = $.param({
        'features': 'accept_agreement',
      });

      // сохраняем модель
      this.user.save(attributes, {
        'success': this.success.bind(this),
        'error': this.error.bind(this),
        'wait': true,
      });

      // возвращаем сохраненный список параметров
      this.user.expand = oldExpand;
    },

    /**
     * Сохранение телефонов.
     */
    savePhoneNumbers: function () {
      this.userPhoneListView.save();
      this.masks.forEach(function (view) {
        view.save();
      });
      this.checkForMobile();
    },

    /**
     * Выполняется в случае успешного сохранения модели user
     */
    success: function () {
      this.successUserData = true;

      this.savePhoneNumbers();
      this.toggleOnSuccess();
      this.clearErrors();
    },

    /**
     * Выполняется в случае ошибки при сохранении модели user
     *
     * @param model Модель
     * @param response Объект ответа
     */
    error: function (model, response) {
      var that = this;
      var errors = JSON.parse(response.responseText);
      this.successUserData = false;

      this.clearErrors();

      errors.forEach(function (error) {
        that.$('#' + error.field + '-error').text(error.message);
        that.$('#' + error.field).addClass('error');
      });
      this.$('.update-user-data-button').prop('disabled', false);
    },

    /**
     * Скрывает сообщения об ошибках и убирает соответствующие классы у полей
     */
    clearErrors: function () {
      var that = this;

      this.$fields.each(function () {
        $(this).removeClass('error');
        that.$el.find('#' + this.name + '-error').text('');
      });
      that.$el.find('#birth_date-error').text('');
      that.$el.find('#accept_agreement-error').text('');
    },

    /**
     * Заполняет поля данными из моделей
     */
    fillFields: function () {
      var that = this;

      that.$fields.each(function () {
        var value = that.user.get(this.name),
          code = app.countryFlag.get('code') || '+7';

        if (value && (this.name !== 'phone' || value.indexOf(code.replace('+', '')) === 0)) {
          $(this).val(value);
        }
      });

      this.fillDateFields();
    },

    /**
     * Заполняет поля, относящиеся к дате рождения
     */
    fillDateFields: function () {
      this.user.parseDate();
      this.$('#birth_day').val(this.user.birth_day);
      this.$('#month' + parseInt(this.user.birth_month)).click();
      this.$('#birth_year').val(this.user.birth_year);
    },

    /**
     * Скрывает форму изменения личных данных
     */
    cancel: function () {
      this.toggle();
      this.trigger('cancel-user-data-form');
      this.fillFields();
      this.clearErrors();
      this.userPhoneListView.restore();
    },

    /**
     * Проверяет данные, введенные в поле на номер мобильного телефона
     */
    checkForMobile: function () {
      var input = this.$('.input_4').first(),
        code = app.countryFlag.get('code') || '+7',
        start = code.length - 1,
        end = start + 3,
        phoneCode = parseInt(input.val().substring(start, end)),
        phoneNumberLength = input.val().length,
        checkForMobile = app.helpers.isMobileHelper.isMobile(phoneCode, phoneNumberLength);
      if (checkForMobile) {
        input.siblings('.can-restore').show();
      } else {
        input.siblings('.can-restore').hide();
      }
    },
  });
})(jQuery);

}.call(window));